import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Company: [],
};
//internally using immer lib (can create mutable state)
export const compnaySlice = createSlice({
  name: "companyData",
  initialState,
  reducers: {
    updateCompany: (state, action) => {
      state.Company = action.payload;
    },
  },
});
// this is for dispatch
export const { updateCompany } = compnaySlice.actions;
// this is for configureStore
export default compnaySlice.reducer;
